// src/app/components/ThemeToggle.tsx
import React, { useState, useEffect } from 'react';
import { FaMoon, FaSun } from 'react-icons/fa';
import './ThemeToggle.css';

const ThemeToggle: React.FC = () => {
  const [darkMode, setDarkMode] = useState<boolean>(false);

  useEffect(() => {
    const savedTheme = localStorage.getItem('darkMode');
    if (savedTheme) {
      setDarkMode(JSON.parse(savedTheme));
    }
  }, []);

  useEffect(() => {
    const bodyElement = document.body;
    if (darkMode) {
      bodyElement.classList.add('dark-mode');
      bodyElement.classList.remove('light-mode');
    } else {
      bodyElement.classList.add('light-mode');
      bodyElement.classList.remove('dark-mode');
    }
    localStorage.setItem('darkMode', JSON.stringify(darkMode));
  }, [darkMode]);

  const handleLightMode = () => {
    setDarkMode(false);
  };

  const handleDarkMode = () => {
    setDarkMode(true);
  };

  return (
    <div className="theme-toggle">
      <button onClick={handleLightMode} className={`btn ${!darkMode ? 'active' : ''}`}>
        <FaSun /> Light
      </button>
      <button onClick={handleDarkMode} className={`btn ${darkMode ? 'active' : ''}`}>
        <FaMoon /> Dark
      </button>
    </div>
  );
};

export default ThemeToggle;
